import {
  Box,
  BoxProps,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { Clear } from '@mui/icons-material';
import { useAtom } from 'jotai';
import { selectedWbsFilter as selectedWbsFilterAtom } from '../../state';
import { WbsFilterOption } from '@/__generated__/graphql';
import { usePersistKpiFilters } from '../../hooks/usePersistKpiFilters';
import { WBS_FILTER_OPTION_LABELS } from '@/constants';

type Props = {} & BoxProps;

export const KpiWbsFilterButton = ({ ...rest }: Props) => {
  const [selectedWbsFilter, setSelectedWbsFilter] = useAtom(selectedWbsFilterAtom);
  const { persistSelectedWbsFilter, loading } = usePersistKpiFilters();

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value as WbsFilterOption;

    persistSelectedWbsFilter(value).then(() => {
      setSelectedWbsFilter(value);
    });
  };

  const handleClear = (event: React.MouseEvent) => {
    event.stopPropagation();
    persistSelectedWbsFilter(undefined).then(() => {
      setSelectedWbsFilter(undefined);
    });
  };

  return (
    <Box {...rest}>
      <Select
        disabled={loading}
        variant="outlined"
        value={selectedWbsFilter ?? ''}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) return 'Select WBS';
          return WBS_FILTER_OPTION_LABELS[selected as WbsFilterOption];
        }}
        sx={{ maxHeight: '3.5rem', width: 140 }}
        onChange={handleChange}
        id="kpi-tracker-wbs-filter-button"
        endAdornment={
          selectedWbsFilter && (
            <InputAdornment
              position="end"
              sx={{
                position: 'absolute',
                right: 25,
                pointerEvents: 'none',
              }}
            >
              <IconButton
                size="small"
                onClick={handleClear}
                disabled={loading}
                aria-label="clear selection"
                sx={{ pointerEvents: 'auto' }}
              >
                <Clear fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }
      >
        {Object.values(WbsFilterOption).map((option) => (
          <MenuItem key={option} value={option}>
            {WBS_FILTER_OPTION_LABELS[option]}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
